import React from 'react';
import logo from "../sandsfp.svg";
import UserForm from "./UserForm";
import "../App.css";


const Home = () => {
    return (
        <div>
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 style={{ padding: "0", margin: "0" }}>Sands Fire Protection</h1>
          <p className="tagline" style={{ padding: "0 0 2rem 0", margin: "0" }}>A Trusted Partner for EVERY Project.</p>
          <h5>
          CALL US TODAY! (512) 677-5857
          </h5>
          <br />
          <UserForm />


        </header>
        </div>
    );
};

export default Home;